require('./RACancelPlanView.scss');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const moment = require('moment');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKLink } = require('commonsComponents/OKLink');
const { LoadingSection } = require('commonsComponents/loadingSection');
const RAOneLineSymbolAmount = require('../../components/commons/RAOneLineSymbolAmount/RAOneLineSymbolAmount');
const RACover = require('../../components/commons/RACover/RACover');
const RAFooter = require('../../components/commons/RAFooter/RAFooter');
const RAInformativeBox = require('../../components/commons/RAInformativeBox/RAInformativeBox');

// @components
const RACancelPlanStep1 = require('../../components/RACancelPlan/RACancelPlanStep1/RACancelPlanStep1');
const RAAccountBox = require('../../components/RAAccountBox/RAAccountBox');
const RALandingSuccess = require('../../components/RALandingSuccess/RALandingSuccess');
const RACustomAccordion = require('../../components/RACustomAccordion/RACustomAccordion');
const RACancelPlanModal = require('./RACancelPlanModal/RACancelPlanModal');

// @actions
const brokerMyInvestments = require('actions/brokerMyInvestments');
const raAccountDetailsActions = require('../../actions/RAAccountDetails');
const raCancelPlanActions = require('../../actions/RACancelPlan');
const portfolioDistributionActions = require('../../actions/RAPortfolioDistribution');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const {
    recordLink,
    recordProcess,
    PROC_RA_CANCEL_SERVICE,
    PROC_START,
    PROC_STEP,
} = require('utilities/tagging');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { getFirstNChars } = require('utilities/stringHelper');
const {
    showWarningMessage,
    getPorfolioOperationStatus,
} = require('../../utilities/RAStatusPortfolioOperationHelper');
const { isTestExpired } = require('../../utilities/RASuitabilityTestHelper');

// @constants
const { MYPROFILE_BROKER_URL, EURO_TEXT } = require('constants/index');
const {
    GO_BACK_URL,
    GOAL_TRACKING_URL,
    MYPROFILE_BROKER_ROBO_URL,
    OBJECTIVE_TRACK_URL_PARA,
    PORTFOLIO_TRACKING_URL,
    PORTFOLIO_TRACK_URL_PARA,
    PROC_RA_CANCEL,
    PROC_RA_START,
    PROC_RA_CANCEL_SERVICE_WALLET,
    RA_GOAL_NOTIFICATION_MODIFIER_SUCCESS,
    RA_GOAL_NOTIFICATION_MODIFIER_WARNING,
    RA_MODIFY_PLAN_URL,
} = require('../../raConstants/index');
const { Portfolios } = require('../../utilities/RAPortfolioHelper');

// @assets
const carImage = require('../../assets/icons/coche.png');
const travelImage = require('../../assets/icons/viaje.png');
const homeImage = require('../../assets/icons/casa.png');
const educationImage = require('../../assets/icons/educacion.png');
const otherImage = require('../../assets/icons/otro.png');

// @Contact Center
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');
const {
    canFinishOperative,
} = require('../../utilities/contactCenter/RACanFinishOperativeHelper');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

class RACancelPlanView extends React.Component {
    constructor(props) {
        super(props);
        this.handleVerifyOTP = this.handleVerifyOTP.bind(this);
        this.handleToggleDisclaimerConfirmation = this.handleToggleDisclaimerConfirmation.bind(
            this,
        );
        this.handleCancelButton = this.handleCancelButton.bind(this);
        this.handleClickModifyPlan = this.handleClickModifyPlan.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.state = {
            showModal: false,
            disclaimerConfirmation: false,
        };
    }

    componentDidMount() {
        const {
            fetchMyInvestments,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const selectedStrategy = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'name',
        ]);
        const eventTag = 'robo cartera ' + selectedStrategy;
        const customData = {
            processDetail: eventTag,
        };

        if (!immGlobalPosition.get('hasRoboHired')) {
            fetchMyInvestments();
        }

        //getCGDAccountNumber(portfolioId);
        this.modalOpen();
        recordProcess(PROC_RA_CANCEL_SERVICE, PROC_START, customData);
        recordLink(PROC_RA_CANCEL_SERVICE, PROC_RA_START, eventTag);
    }

    componentWillUnmount() {
        this.props.reset();
    }

    closeModal() {
        if (this.state.showModal) {
            this.setState({
                showModal: false,
            });
        }
    }

    modalOpen() {
        const {
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;

        const immPortfolioState = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'state',
        ]);

        if (immPortfolioState) {
            const tradingOnHold = immPortfolioState.get('tradingOnHold');
            const strategyChange = immPortfolioState.get('strategyChange');
            const monthlyRebalancing = immPortfolioState.get(
                'monthlyRebalancing',
            );

            if (
                showWarningMessage(
                    tradingOnHold,
                    strategyChange,
                    monthlyRebalancing,
                )
            ) {
                this.setState({
                    showModal: true,
                });
            }
        }
    }

    getBreadcrumb() {
        const {
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;

        const origin = immGlobalPosition.get('originRedirection');
        let parentTitle;
        let parentUrl;
        if (origin === PORTFOLIO_TRACK_URL_PARA) {
            parentTitle = formatText(
                'raPortfolioTracking-raPortfolioTracking_breadcrumbThird',
            );
            parentUrl = `${PORTFOLIO_TRACKING_URL}/${portfolioId}`;
        } else if (origin === OBJECTIVE_TRACK_URL_PARA) {
            parentTitle = formatText('breadcrumb-breadcrumb_objectiveTracking');
            parentUrl = `${GOAL_TRACKING_URL}/${portfolioId}`;
        }

        return [
            {
                text: formatText('raManagementPlan-investments'),
                url: MYPROFILE_BROKER_URL,
            },
            {
                text: formatText(
                    'raCancelPlan-raCancelPlan_investForYouBreadcrumb',
                ),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            ...(origin === PORTFOLIO_TRACK_URL_PARA ||
            origin === OBJECTIVE_TRACK_URL_PARA
                ? [
                      {
                          text: parentTitle,
                          url: parentUrl,
                      },
                  ]
                : []),
            {
                text: formatText('raCancelPlan-cancelRequestBreadcrumb'),
            },
        ];
    }

    handleClickModifyPlan() {
        this.props.history.push(
            `${RA_MODIFY_PLAN_URL}/${this.props.match.params.portfolioId}`,
        );
    }

    handleVerifyOTP() {
        this.props.finish(
            this.props.history,
            this.props.match.params.portfolioId,
        );
    }

    buildOTPSection() {
        const {
            immSignaturePattern,
            immCancelPlan,
            immGlobalPosition,
            immPrinter,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const isDisabled = !__CONTACT_CENTER__
            ? !immSignaturePattern.get('isFetchingConfigSuccess') ||
              !immSignaturePattern.get('inputValueSMS')
            : !canFinishOperative(immSignaturePattern, immPrinter);
        const isLoading = immCancelPlan.get('isLoading');
        const button = (
            <div className="ra-cancel-plan-view__otp-card-btn">
                <OKButton
                    modifier="primary"
                    onClick={this.handleVerifyOTP}
                    disabled={isDisabled}
                    loading={isLoading}
                >
                    <FormattedText value="roboWizard-confirm" />
                </OKButton>
            </div>
        );
        const immAccount = immGlobalPosition.getIn([
            'roboAccount',
            portfolioId,
        ]);

        return (
            <RACustomAccordion
                activateOnClickOfAccordion={true}
                isExpanded={
                    __CONTACT_CENTER__ || this.state.disclaimerConfirmation
                }
                leftIconClass="ra-accordion-wizard-step__icon ra-accordion-wizard-step__icon--active icon-firma"
                title={formatText('raCancelPlan-otpTitle')}
                customClassName="ra-accordion-wizard-step ra-accordion-wizard-step--active"
                customTitleClassName="ra-accordion-wizard-step__header-title ra-accordion-wizard-step__header-title--active ra-accordion-wizard-step__header-title--cancel-plan"
            >
                <RACancelPlanStep1
                    immPortfolio={this.getCurrentPortfolio()}
                    immAccount={immAccount}
                />
                {button}
            </RACustomAccordion>
        );
    }

    buildConfirmCheckbox(textKey) {
        const disclaimerText = formatText(
            `raCancelPlan-disclaimerText${textKey}`,
        );

        return (
            <OKCheckbox
                idName="ra-cancel-plan-disclaimer-checkbox"
                label={disclaimerText}
                onChange={this.handleToggleDisclaimerConfirmation}
                disabled={false}
                value={this.state.disclaimerConfirmation}
            />
        );
    }

    handleCancelButton() {
        const {
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const selectedStrategy = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'name',
        ]);
        const eventTag = PROC_RA_CANCEL_SERVICE_WALLET + selectedStrategy;
        recordLink(PROC_RA_CANCEL_SERVICE, PROC_RA_CANCEL, eventTag);
    }

    handleToggleDisclaimerConfirmation() {
        const {
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const selectedStrategy = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'name',
        ]);
        const eventTag = PROC_RA_CANCEL_SERVICE_WALLET + selectedStrategy;
        const nextStep = !this.state.disclaimerConfirmation
            ? PROC_STEP + 1
            : PROC_RA_START;

        recordLink(PROC_RA_CANCEL_SERVICE, nextStep, eventTag);
        this.setState({
            disclaimerConfirmation: !this.state.disclaimerConfirmation,
        });
    }

    getGoalIconImage(goalType) {
        switch (goalType) {
            // @Temporally logic, TODO: change RACircularProgressIcon to implement as modifier class
            case 'CAR':
                return carImage;
            case 'TRAVEL':
                return travelImage;
            case 'HOME':
                return homeImage;
            case 'EDUCATION':
                return educationImage;
            case 'OTHERS':
                return otherImage;
            default:
                return '';
        }
    }

    getPortfolioIcon(immPortfolio) {
        const portfolioHasGoal = immPortfolio.get('hasGoal');
        if (portfolioHasGoal) {
            const goalType = immPortfolio.getIn([
                'goalInformation',
                'goalType',
            ]);
            return this.getGoalIconImage(goalType);
        } else {
            const productCode = immPortfolio.getIn([
                'product',
                'typeOfProduct',
            ]);
            return Portfolios[productCode].iconLine;
        }
    }

    getPortfolioName(immPortfolio) {
        let portfolioName;
        if (immPortfolio) {
            portfolioName = immPortfolio.get('hasGoal')
                ? immPortfolio.getIn(['goalInformation', 'name'])
                : immPortfolio.get('name');
        }
        return portfolioName;
    }

    getCurrentPortfolio() {
        const { immGlobalPosition, match } = this.props;
        const trackingPortfolioId = match.params.portfolioId;
        return immGlobalPosition.getIn(['portfolios', trackingPortfolioId]);
    }

    buildLegalTextSection() {
        if (!__CONTACT_CENTER__) {
            return null;
        }

        return (
            <BlockInfo extraClass="ra-cancel-plan-view__legal-text-info-block">
                <div className="ra-cancel-plan-view__legal-text-info-block-content">
                    <p className="ra-cancel-plan-view__legal-text-paragraph">
                        <FormattedText
                            className="ra-cancel-plan-view__legal-text"
                            value="raCancelPlan-legalText1"
                        />
                    </p>
                    <p className="ra-cancel-plan-view__legal-text-paragraph">
                        <FormattedText
                            className="ra-cancel-plan-view__legal-text"
                            value="raCancelPlan-legalText2"
                        />
                    </p>
                    <p className="ra-cancel-plan-view__legal-text-paragraph">
                        <FormattedText
                            className="ra-cancel-plan-view__legal-text"
                            value="raCancelPlan-legalText3"
                        />
                    </p>
                    <p>
                        <FormattedText
                            className="ra-cancel-plan-view__legal-text"
                            value="raCancelPlan-legalText4"
                        />
                    </p>
                </div>
            </BlockInfo>
        );
    }

    buildWarningDisclaimer() {
        const linkText = (
            <FormattedText value="raCancelPlan-raCancelPlan_modifiyPlanLink" />
        );

        const linkModifier = __CONTACT_CENTER__ ? 'inline' : 'widget';

        const linkElement = (
            <OKLink
                modifier={linkModifier}
                onClick={this.handleClickModifyPlan}
            >
                {linkText}
            </OKLink>
        );

        const phoneNumber = (
            <FormattedText value="brokerInvestmentSpecialist-brokerInvestmentSpecialistPhone" />
        );
        const titleText = (
            <FormattedText value="raCancelPlan-raCancelPlan_warningTitle" />
        );

        const content = (
            <FormattedTextWithComponents
                value="raCancelPlan-raCancelPlan_warningDescription"
                injectedComponents={[phoneNumber, linkElement]}
            />
        );
        return (
            <React.Fragment>
                <WebappRender>
                    <div className="ra-cancel-plan-view__warning">
                        <RAInformativeBox title={titleText}>
                            {content}
                        </RAInformativeBox>
                    </div>
                </WebappRender>
                <ContactCenterRender>
                    <BlockInfo extraClass="ra-cancel-plan-view__warning">
                        {content}
                    </BlockInfo>
                </ContactCenterRender>
            </React.Fragment>
        );
    }

    buildWizardSection() {
        //const { immAccountDetails } = this.props;
        const { immRAFeatureFlag } = this.props;
        const owner = this.props.immProfileFields.get('fullname');
        const immPortfolio = this.getCurrentPortfolio();
        //const accountName = `${immAccountDetails.get('accountAlias')} ${getLastNChars(immAccountDetails.get('accountNumber'))}`;
        const currentValue = immPortfolio.getIn(['keyFigures', 'valuation']);
        const otpSection = this.buildOTPSection();
        const warningDisclaimer = immRAFeatureFlag.get('changeProduct')
            ? this.buildWarningDisclaimer()
            : null;
        const textKey = immPortfolio.get('hasGoal') ? 'goal' : '';
        const sectionContent = (
            <div className="ra-cancel-plan-view__section-info">
                <FormattedText value="raCancelPlan-raCancelPlan_modifySectionInfo" />
            </div>
        );
        const confirmationSection = this.buildConfirmCheckbox(textKey);
        const legalTextSection = this.buildLegalTextSection();
        let iconType, goalModifier;
        if (immPortfolio.get('hasGoal')) {
            const goalDate = immPortfolio.getIn([
                'goalInformation',
                'goalDate',
            ]);
            const goalProgress = immPortfolio.getIn([
                'goalInformation',
                'goalProgress',
            ]);
            const goalNotReached =
                goalProgress < 1 &&
                moment(goalDate).isSameOrBefore(moment(), 'day');
            const goalReached = goalProgress >= 1;

            if (goalReached || goalNotReached) {
                iconType = immPortfolio
                    .getIn(['goalInformation', 'goalType'])
                    .toLowerCase();
                goalModifier = goalReached
                    ? RA_GOAL_NOTIFICATION_MODIFIER_SUCCESS
                    : RA_GOAL_NOTIFICATION_MODIFIER_WARNING;
            }
        }

        return (
            <div>
                {warningDisclaimer}
                <div
                    id="printable-wizard"
                    className="ra-cancel-plan-view__wizard-section"
                >
                    <div className="ra-cancel-plan-view__section ra-cancel-plan-view__section--first ra-cancel-plan-view__legal-text-section">
                        {sectionContent}
                        {legalTextSection}
                    </div>

                    <RAAccountBox
                        iconType={iconType}
                        goalModifier={goalModifier}
                        productName={this.getPortfolioName(immPortfolio)}
                        productIcon={this.getPortfolioIcon(immPortfolio)}
                        //accountName={accountName}
                        accountOwner={owner}
                        currentValue={currentValue}
                    />
                </div>
                <WebappRender>
                    <div className="row">
                        <div className="col-xs-12">{confirmationSection}</div>
                    </div>
                </WebappRender>
                <div className="row">
                    <div className="col-xs-12">{otpSection}</div>
                </div>
                <div className="row ra-cancel-plan-view__footer">
                    <div className="col-xs-12">
                        <RAFooter
                            cancelPath={GO_BACK_URL}
                            onLeftButtonClick={this.handleCancelButton}
                        />
                    </div>
                </div>
            </div>
        );
    }

    buildSuccessfulSection() {
        const { immGlobalPosition, immProfileFields, match } = this.props;

        const owner = immProfileFields.get('fullname');
        const trackingPortfolioId = match.params.portfolioId;
        const immPortfolio = immGlobalPosition.getIn([
            'portfolios',
            trackingPortfolioId,
        ]);

        const actualValue = immPortfolio.getIn(['keyFigures', 'valuation']);
        const actualValueObject = {
            amount: actualValue,
            currency: EURO_TEXT,
        };
        const actualValueFormatted = (
            <RAOneLineSymbolAmount amountObject={actualValueObject} />
        );

        const resumeContent = [
            {
                label: formatText('raCancelPlan-resumeAccount'),
                value: getFirstNChars(this.getPortfolioName(immPortfolio), 20),
            },
            {
                label: formatText('raCancelPlan-resumeOwner'),
                value: owner,
            },
            {
                label: formatText('raCancelPlan-resumeValue'),
                value: actualValueFormatted,
            },
            {
                label: formatText('raCancelPlan-resumeDestiny'),
                value: formatText(
                    'raCancelPlan-raCancelPlan_resumeDestinyValue',
                ),
            },
        ];
        const resumeTitle = formatText('raCancelPlan-resumeTitle');
        const mainButton = formatText('raCancelPlan-mainButton');
        const informativeTitle = formatText('raCancelPlan-informativeTitle');
        const informativeContent = (
            <div className="row ra-cancel-plan-view__informative-box">
                <FormattedText value="raCancelPlan-informativeContent1" />
            </div>
        );
        const valuation = immPortfolio.getIn(['keyFigures', 'valuation']);
        return (
            <RALandingSuccess
                title={resumeTitle}
                resumeContent={resumeContent}
                mainButton={mainButton}
                mainButtonURL={MYPROFILE_BROKER_ROBO_URL}
                onRender={() =>
                    window &&
                    window.utag &&
                    window.utag.view &&
                    window.utag.view({ ammount: valuation })
                }
            >
                <RAInformativeBox title={informativeTitle}>
                    {informativeContent}
                </RAInformativeBox>
            </RALandingSuccess>
        );
    }

    buildModal(tradingOnHold, strategyChange, monthlyRebalancing) {
        const {
            cancelModifyPlanModal,
            immGlobalPosition,
            immCheckStatus,
            match: {
                params: { portfolioId },
            },
        } = this.props;

        const testExpired = isTestExpired(immCheckStatus);

        const hasGoal = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'hasGoal',
        ]);
        const hasGoalKey = hasGoal ? 'Goal' : 'Portfolio';

        const status = getPorfolioOperationStatus(
            tradingOnHold,
            strategyChange,
            monthlyRebalancing,
        );

        const titleKey = `raCancelPlan-modalOperationStatus_title${status}`;
        const contentKey1 = `raCancelPlan-modalOperationStatus_content${hasGoalKey}${status}1`;
        const contentKey2 = `raCancelPlan-modalOperationStatus_content${hasGoalKey}${status}2`;
        const linkTextKey = `raCancelPlan-modalOperationStatus_link${status}`;
        const buttonTextKey = `raCancelPlan-modalOperationStatus_buttonText${status}`;

        let modalData = {
            title: titleKey,
            linkText: linkTextKey,
            content1: contentKey1,
            content2: contentKey2,
            buttonText: buttonTextKey,
        };

        if (__CONTACT_CENTER__) {
            switch (status) {
                case 'OrderInProgress':
                case 'RebalancingByCommittee':
                case 'StrategyChangeInProgress':
                    const contentKey3 = `raCancelPlan-modalOperationStatus_content${hasGoalKey}${status}3`;
                    modalData = {
                        ...modalData,
                        content3: contentKey3,
                    };
                    break;
                case 'NoOrdersNoRebalancing':
                default:
                    break;
            }
        }
        const modalUrl = `/myprofile/robo/modifyPlan/${portfolioId}`;

        return (
            <RACancelPlanModal
                showModal={this.state.showModal}
                modalUrl={modalUrl}
                modalData={modalData}
                closeModal={this.closeModal}
                cancelModifyPlanModal={cancelModifyPlanModal}
                isTestExpired={testExpired}
            />
        );
    }

    render() {
        const { immCancelPlan } = this.props;
        const submitSuccessful = immCancelPlan.get('submitSuccessful');
        const breadcrumb = this.getBreadcrumb();
        const immPortfolio = this.getCurrentPortfolio();
        let cover;
        let content;
        let modal;

        if (immPortfolio && immPortfolio.get('hasGoal')) {
            const goalType = immPortfolio.getIn([
                'goalInformation',
                'goalType',
            ]);

            cover = (
                <RACover
                    section="goal"
                    goalType={goalType}
                    breadcrumb={breadcrumb}
                    success={submitSuccessful}
                    successTitle={formatText('raCancelPlan-headerSuccessTitle')}
                    title={formatText('raCancelPlan-headerTitleGoal')}
                />
            );
        } else {
            cover = (
                <RACover
                    breadcrumb={breadcrumb}
                    success={submitSuccessful}
                    successTitle={formatText('raCancelPlan-headerSuccessTitle')}
                    title={formatText('raCancelPlan-headerTitle')}
                />
            );
        }

        if (submitSuccessful) {
            content = this.buildSuccessfulSection();
        } else {
            content = immCancelPlan.get('investmentsFetched') ? (
                this.buildWizardSection()
            ) : (
                <LoadingSection />
            );
        }

        if (immPortfolio && immPortfolio.get('state')) {
            const immPortfolioState = immPortfolio.get('state');
            const tradingOnHold = immPortfolioState.get('tradingOnHold');
            const strategyChange = immPortfolioState.get('strategyChange');
            const monthlyRebalancing = immPortfolioState.get(
                'monthlyRebalancing',
            );

            modal = showWarningMessage(
                tradingOnHold,
                strategyChange,
                monthlyRebalancing,
            )
                ? this.buildModal(
                      tradingOnHold,
                      strategyChange,
                      monthlyRebalancing,
                  )
                : null;
        }

        return (
            <div className="ra-cancel-plan-view grid-view">
                <div className="container-fluid">
                    <div className="row">{cover}</div>
                </div>
                {modal}
                <div className="row ra-cancel-plan-view__container">
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xs-12">{content}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RACancelPlanView.propTypes = {
    cancelModifyPlanModal: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    getCGDAccountNumber: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccountDetails: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object,
    immCancelPlan: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    immObjectiveDetailsReducer: PropTypes.object.isRequired,
    immPrinter: PropTypes.object.isRequired,
    immRAFeatureFlag: PropTypes.object.isRequired,
    immCheckStatus: PropTypes.object.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    finish: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        immAccountDetails: state.raAccountDetails,
        immProfileFields: state.profile,
        immCancelPlan: state.raCancelPlan,
        immGlobalPosition: state.raGlobalPosition,
        immSignaturePattern: state.signaturePattern,
        immObjectiveDetailsReducer: state.raObjectiveDetailsReducer,
        immPrinter: state.printer,
        immRAFeatureFlag: state.raFeatureFlag,
        immCheckStatus: state.raCheckStatus,
    }),
    {
        cancelModifyPlanModal:
            portfolioDistributionActions.cancelModifyPlanModal,
        fetchMyInvestments: brokerMyInvestments.fetchMyInvestments,
        finish: raCancelPlanActions.finish,
        getCGDAccountNumber: raAccountDetailsActions.getCGDAccountNumber,
        reset: raCancelPlanActions.reset,
    },
)(withRouter(RACancelPlanView));
